import { render } from "./Abertura_Embalagem.vue?vue&type=template&id=723a28fe&scoped=true"
import script from "./Abertura_Embalagem.vue?vue&type=script&lang=js"
export * from "./Abertura_Embalagem.vue?vue&type=script&lang=js"

import "./Abertura_Embalagem.vue?vue&type=style&index=0&id=723a28fe&lang=css"
import "./Abertura_Embalagem.vue?vue&type=style&index=1&id=723a28fe&scoped=true&lang=css"
import "./Abertura_Embalagem.vue?vue&type=style&index=2&id=723a28fe&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723a28fe"]])

export default __exports__